<template>
  <v-layout row wrap>
    <v-radio-group v-model="currentOffer">
      <OfferCard
        v-for="offer in loanOffers"
        :offer="offer"
        :key="offer.offer_id"
      />
    </v-radio-group>
  </v-layout>
</template>

<script>
  import OfferCard from 'Components/OfferCard.vue'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'SelectOffer',
    components: {
      OfferCard
    },
    data () {
      return {
        currentOffer: {}
      }
    },
    computed: {
      ...mapState({
        lender: state => state.loanApplication.lender,
        loanOffers: state => state.loanApplication.loanOffers
      })
    },
    methods: {
      ...mapActions([
        'selectOffer'
      ])
    },
    watch: {
      currentOffer () {
        this.selectOffer({
          offer: this.currentOffer
        })
      }
    },
    mounted () {
      this.currentOffer = this.loanOffers[0]
    }
  }
</script>
